import React from 'react'

export default function Footer() {
  const year = new Date().getFullYear()
  return (
    <footer className="w-full border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 text-sm text-gray-600 dark:text-gray-300">
      <div className="container mx-auto px-4 py-4 flex flex-col md:flex-row items-center justify-between gap-2">
        <div className="flex items-center gap-3">
          <span className="font-semibold">VeriDocAI</span>
          <span className="hidden md:inline">&middot;</span>
          <span className="text-xs">Legal Document Summarizer</span>
        </div>
        <div className="flex items-center gap-4">
          <nav aria-label="Footer links" className="flex items-center gap-3">
            <a href="https://veridocai.com/docs" className="hover:underline" target="_blank" rel="noopener noreferrer">Docs</a>
            <a href="https://veridocai.com/whats-new" className="hover:underline" target="_blank" rel="noopener noreferrer">What&rsquo;s new</a>
            <a href="https://veridocai.com/privacy" className="hover:underline" target="_blank" rel="noopener noreferrer">Privacy</a>
          </nav>
          <div className="text-xs text-gray-500">© {year} VeriDocAI</div>
        </div>
      </div>
    </footer>
  )
}
